import { useFirestoreCollection } from './useFirestoreCollection';
import { handoversService } from '../services/firestore';
import type { HandoverRequest } from '../types';

/**
 * Hook for subscribing to handover queue with real-time updates
 */
export function useHandoverQueue(
  propertyId: string | undefined,
  status?: HandoverRequest['status']
) {
  return useFirestoreCollection<HandoverRequest>(
    (onUpdate, onError) => {
      if (!propertyId) {
        onUpdate([]);
        return () => {};
      }
      return handoversService.subscribeToQueue(propertyId, onUpdate, onError, status);
    },
    [propertyId, status]
  );
}

/**
 * Hook for subscribing to pending handovers (most common use case)
 */
export function usePendingHandovers(propertyId: string | undefined) {
  return useHandoverQueue(propertyId, 'pending');
}

/**
 * Hook for subscribing to agent's assigned handovers
 */
export function useAgentHandovers(agentId: string | undefined) {
  return useFirestoreCollection<HandoverRequest>(
    (onUpdate, onError) =>
      agentId ? handoversService.subscribeToAgentHandovers(agentId, onUpdate, onError) : (() => {}),
    [agentId]
  );
}
